<template>
    <div>
        <div class="card card-default" v-if="invitations.length > 0">
            <div class="card-header">Mailed Team Invitations</div>

            <div class="table-responsive">
                <table class="table table-valign-middle mb-0">
                    <thead>
                    <tr>
                        <th>E-Mail Address</th>
                        <th class="th-fit">&nbsp;</th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr class="reveal" v-for="(invitation, index) in invitations">
                        <!-- E-Mail Address -->
                        <td>
                            <div>
                                {{ invitation.email }}
                            </div>
                        </td>

                        <!-- Delete Button -->
                        <td class="td-fit">
                            <div class="text-right ">
                                <span :class="'link-copied-'+index" style="display: none;">Link copied to clipboard</span>
                                <button class="btn btn-outline-primary copy-to-clipboard" type="button" data-toggle="tooltip" data-placement="top" title="Copy Invitation Link" @click="copyToClipBoard(invitation, index)">
                                    <i class="fa fa-clipboard"></i>
                                </button>
                                <button class="btn btn-outline-danger" @click="cancel(invitation)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'team-invites',
    data: () => ({
        invitations: [],
    }),
    mounted() {
        this.fetchTeamInvitations()
    },

    methods: {
        fetchTeamInvitations(){
            axios.get(route('spark.kiosk.teams.invitations'))
                .then(({data}) => {
                    this.invitations = data.data;
                });
        },
        copyToClipBoard(invitation, index) {
            let $temp = $("<input>");
            $("body").append($temp);
            $temp.val(route('register')+ '?token='+invitation.token).select();
            document.execCommand("copy");
            $temp.remove();
            $('.link-copied-'+index).show(300);
            setTimeout(()=>{
                $('.link-copied-'+index).hide(300);
            }, 3000);
        },
        cancel(invitation) {
            axios.delete(`/spark/kiosk/delete-invitation/${invitation.id}`)
                .then(() => {
                    this.fetchTeamInvitations()
                });
        },
    }
}
</script>
